import React, {useState, useEffect} from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import 'bootstrap/dist/css/bootstrap.min.css';

import appSettings from "../../appSettings.json";
import './MessageList.css'
import HTMLViewer from '../../shared/components/HTMLViewer/HTMLViewer';
import FileIcon from '../../shared/components/FileIcon/FileIcon';
import createFileURL from '../../shared/utilities/createFileURL';
import isFilled from '../../shared/utilities/isFilled';
import useFetch from '../../shared/hooks/useFetch';

const MessageList = (props) => {
    const { user, ticket } = props

    const[open, setOpen] = useState(false);
    const[openAttach, setOpenAttach] = useState(false);

    const conversation = [...ticket.mensaje, ...ticket.adjunto].sort((a, b) => {
        return new Date(a.creacion).getTime() - new Date(b.creacion).getTime();
    });

    const formatDateTime = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return '';
        const pad2 = (value) => String(value).padStart(2, '0');
        const day = pad2(date.getDate());
        const month = pad2(date.getMonth() + 1);
        const year = String(date.getFullYear()).slice(-2);
        const hours = pad2(date.getHours());
        const minutes = pad2(date.getMinutes());
        const seconds = pad2(date.getSeconds());
        return `${day}-${month}-${year} / ${hours}:${minutes}:${seconds}`;
    };

    const handleImageClick = (imageSrc) => {
        if(isFilled(imageSrc)) window.open(createFileURL(window.atob(imageSrc.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')), ".PNG", setOpen))
    };

    /* Llamada API metodo get-file-tickets */
    const[fileSelected, setFileSelected] = useState()
    const[getFileUrl, setGetFileUrl] = useState()

    const[messageFile, setMessageFile] = useState("");
    const[successFile, setSuccessFile] = useState(false);

    const {serviceResponse, error, loading} = useFetch(getFileUrl, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'GET', "", fileSelected)

    useEffect(() => {
        if(!loading && isFilled(fileSelected)){
            setFileSelected(undefined)
            setMessageFile(serviceResponse.message)
            setSuccessFile(serviceResponse.success)

            window.open(createFileURL(window.atob(serviceResponse.data), `.${fileSelected.nombre.split('.').pop()}`, setOpenAttach))
        }
    }, [loading, serviceResponse, error])

    /*const downloadFile = (file) => {
        setGetFileUrl(`${appSettings.BASE_URL.default}/ticket/get-file-tickets?fileNameId=${file.nombreId}`)
        setFileSelected(file)
    }*/

    const openFileInNewTab = (mensaje) => {
        setGetFileUrl(`${appSettings.BASE_URL.default}/ticket/get-file-tickets?fileNameId=${mensaje.nombreId}`)
        setFileSelected(mensaje)
    };

    const getMimeType = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        const mimeTypes = {
            txt: "text/plain",
            pdf: "application/pdf",
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            csv: "text/csv",
            json: "application/json",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            xls: "application/vnd.ms-excel",
            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            zip: "application/zip",
            rar: "application/vnd.rar"
        };

        return mimeTypes[extension] || "application/octet-stream";
    };

    const downloadFile = async (mensaje) => {
    try {
        const response = await fetch(`${appSettings.BASE_URL.default}/ticket/get-file-tickets?fileNameId=${mensaje.nombreId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${user.token}` 
            }
        });

        if (!response.ok) {
            throw new Error("No se pudo descargar el archivo");
        }

        const result = await response.json();

        if (!result.success) {
            throw new Error(result.message || "Error al obtener el archivo");
        }

        const base64Data = result.data;

        // Convertir Base64 a bytes
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {
            type: getMimeType(mensaje.nombre)
        });

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = mensaje.nombre || "archivo";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error("Error al descargar el archivo:", error);
    }
};

    return (
        <div className='container-fluid'>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={open} onClose={() => {setOpen(false)}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al abrir la imagen en otra pestaña"}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={openAttach} onClose={() => {setOpenAttach(false)}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al abrir el archivo en otra pestaña"}
                </Alert>
            </Snackbar>
            {isFilled(conversation)
            ?
                conversation.map((mensaje, key) => (
                    <div key={key}>
                        <div className='row'>
                            <div className = {mensaje.usuario.rol == "SAT" ? 'col-6 chat-bubble received ms-auto' : 'col-6 chat-bubble sent'}>
                                <div className="message-meta">
                                    <span style={{fontSize: "15px", fontWeight: "500"}}>{mensaje.usuario.nombre}</span>
                                    <span style={{fontSize: "15px"}}>{formatDateTime(mensaje.creacion)}</span>
                                </div>
                                <br/>
                                {isFilled(mensaje.contenido) ? (
                                        <div className='htmlContent'>
                                            <HTMLViewer html={mensaje.contenido} onImageClick={handleImageClick} />
                                        </div>
                                    ) : isFilled(mensaje.nombre) ? (
                                        <div className='row align-items-center'>
                                            <FileIcon
                                                className='divFileIcon'
                                                extension={mensaje.nombre.split('.').pop()}
                                            />

                                            <div className='col'>
                                                <span>{mensaje.nombre}</span>
                                                <br />
                                                <span style={{ fontSize: "12px" }}>{`${mensaje.size} Bytes`}</span>
                                            </div>

                                            <div className='d-flex gap-2 mt-2'>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm" style={{backgroundColor: "#ffffff", color: "#2563eb",  borderRadius: "8px",  fontWeight: 500}}
                                                    onClick={() => openFileInNewTab(mensaje)}
                                                >
                                                    Abrir
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-sm" style={{backgroundColor: "#ffffff", color: "#00c851",  borderRadius: "8px",  fontWeight: 500}}
                                                    onClick={() => downloadFile(mensaje)}
                                                >
                                                    Descargar
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                )}
                                
                            </div>
                        </div>
                    </div>
                ))
            :
                <></>
            }
        </div>
    )
}

export default MessageList;
